import styled from 'styled-components';

export const StyledDropzoneContainer = styled.div`
    border: 2px dashed ${({ theme }) => theme.gray7};
    border-radius: 16px;
    padding: 48px 0;
    background: ${({ theme }) => theme.gray11};
    text-align: center;
    position: relative;
    margin-bottom: 16px;
    cursor: pointer;

    @media (max-width: 768px) {
        button {
            max-width: 50%;
        }
    }
`;

export const StyledFileDescription = styled.div`
    margin-bottom: 16px;
`;

export const StyledDragLabel = styled.div`
    color: ${({ theme }) => theme.gray2};
    margin-bottom: 8px;
`;

export const StyledOrLabel = styled.div`
    color: ${({ theme }) => theme.gray3};
    margin-bottom: 8px;
`;

export const StyledFileProperties = styled.div`
    color: ${({ theme }) => theme.gray3};
    display: flex;
    justify-content: space-between;
    margin-bottom: 8px;
    font-size: 14px;
`;

export const StyledFileRow = styled.div`
    display: flex;
    align-items: center;
    background: ${({ theme }) => theme.gray10};
    border-radius: 12px;
    padding: 12px;
    padding-right: 24px;
    margin-top: 16px;
    position: relative;
`;

export const StyledFileIcon = styled.div`
    width: 48px;
    height: 48px;
    background: ${({ theme }) => theme.gray11};
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 16px;
    font-size: 2rem;
`;

export const StyledFileInfo = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
`;

export const StyledFileName = styled.div`
    font-weight: 600;
    color: ${({ theme }) => theme.gray2};
`;

export const StyledFileSize = styled.div`
    font-size: 1.2rem;
    color: ${({ theme }) => theme.gray4};
`;

export const StyledProgressBar = styled.div<{ percent: number }>`
    width: 100%;
    height: 8px;
    background: ${({ theme }) => theme.gray11};
    border-radius: 4px;
    margin-top: 12px;
    overflow: hidden;
    &::after {
        content: '';
        display: block;
        height: 100%;
        width: ${({ percent }) => percent}%;
        background: repeating-linear-gradient(
            135deg,
            ${({ theme }) => theme.gray2},
            ${({ theme }) => theme.gray2} 10px,
            ${({ theme }) => theme.gray4} 10px,
            ${({ theme }) => theme.gray4} 20px
        );
        border-radius: 4px;
        transition: width 0.3s;
    }
`;

export const StyledRemoveButton = styled.button`
    background: none;
    border: none;
    color: ${({ theme }) => theme.gray2};
    cursor: pointer;
    margin-left: 16px;
    font-size: 1.5rem;
    display: flex;
    align-items: center;
`;

export const StyledFileThumbnailContainer = styled.div`
    width: 30px;
    height: 30px;
    borderradius: 8px;
    overflow: hidden;
`;

export const StyledImageThumbnail = styled.img`
    width: 100%;
    height: 100%;
    objectfit: cover;
`;

export const StyledFileThumbnail = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    alignitems: center;
    justifycontent: center;
    fontsize: 12;
`;
